export default "__VITE_ASSET__gneZtnrA__"